import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const CommunicationCancelation = loadable(() => pMinDelay(import('./CommunicationCancelation'), 300), {
  fallback: <Loading />
});

const AsyncCommunicationCancelation = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      },
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/antd/antd.min.css'
        }
      ]
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <CommunicationCancelation { ...props }/>
    </ApplicationLayout>
  );
};

AsyncCommunicationCancelation.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncCommunicationCancelation;
